// extracted by mini-css-extract-plugin
export var blockedMessage = "_br-3";
export var blockedOverlay = "_br-1";
export var fadeIn = "_br-2";
export var hereLink = "_br-0";
export var slideUp = "_br-4";